import type { ButtonHTMLAttributes } from 'react';

interface FormCancelButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

export function FormCancelButton({ children = 'Anuluj', disabled, className = '', ...props }: FormCancelButtonProps) {
  return (
    <button type="button" className={`btn btn-link ${className}`} disabled={disabled} {...props}>
      {children}
    </button>
  );
}
